// extracted by mini-css-extract-plugin
export default {"content":"Body_content__1TmTI","actions":"Body_actions__tPdmM"};